<!-- field-group.component.html -->
<div class="field-group-container" [ngClass]="config.cssClass">
  <!-- Header with Add Button -->
  <div class="field-group-header">
    <div class="header-content">
      <h6 *ngIf="config.groupTitle" class="group-title">
        <i class="bi bi-collection me-2"></i>
        {{ config.groupTitle }}
      </h6>
      <button
        type="button"
        kendoButton
        [fillMode]="'outline'"
        [themeColor]="'primary'"
        [size]="'small'"
        [disabled]="!canAddInstance"
        (click)="addInstance()"
        class="add-instance-btn"
      >
        <i class="bi bi-plus-circle me-1"></i>
        {{ config.addButtonText }}
      </button>
    </div>
  </div>

  <!-- Empty State -->
  <div *ngIf="instances.length === 0" class="empty-state">
    <div class="empty-state-content">
      <i class="bi bi-inbox empty-icon"></i>
      <p class="empty-text">No items added yet</p>
      <p class="empty-hint">Click "{{ config.addButtonText }}" to add your first item</p>
    </div>
  </div>

  <!-- Group Instances -->
  <div class="field-group-instances">
    <div
      *ngFor="let instance of instances; let i = index; trackBy: trackByInstance"
      class="field-group-instance"
      [class.collapsed]="instance.collapsed"
    >
      <!-- Instance Header -->
      <div class="instance-header">
        <div class="instance-header-left">
          <button
            *ngIf="config.collapsible"
            type="button"
            class="btn btn-link btn-sm collapse-toggle"
            (click)="toggleInstanceCollapse(i)"
          >
            <i
              class="bi"
              [class.bi-chevron-down]="!instance.collapsed"
              [class.bi-chevron-right]="instance.collapsed"
            ></i>
          </button>
          <span class="instance-title">{{ getInstanceTitle(i) }}</span>
        </div>

        <div class="instance-header-right">
          <button
            type="button"
            kendoButton
            [fillMode]="'flat'"
            [themeColor]="'error'"
            [size]="'small'"
            [disabled]="!canRemoveInstance"
            (click)="removeInstance(i)"
            class="remove-instance-btn"
            [attr.aria-label]="'Remove ' + getInstanceTitle(i)"
          >
            <i class="bi bi-trash"></i>
            {{ config.removeButtonText }}
          </button>
        </div>
      </div>

      <!-- Instance Fields -->
      <div class="instance-fields" [class.collapsed-content]="instance.collapsed">
        <div class="row g-3" [formGroup]="getInstanceControl(i)">
          <ng-container *ngFor="let field of config.fields">
            <div
              *ngIf="isFieldVisible(field, i)"
              [ngClass]="getGridClass(field)"
              class="form-field-wrapper"
            >
              <ng-container [ngSwitch]="field.controlType">
                <!-- Input Field -->
                <app-input
                  *ngSwitchCase="'input'"
                  [formControlName]="field.formControlName"
                  [config]="field.config || {}"
                  [validation]="field.validation || {}"
                >
                </app-input>

                <!-- Select Field - UPDATED: Pass instanceIndex -->
                <app-select
                  *ngSwitchCase="'select'"
                  [formControlName]="field.formControlName"
                  [config]="getFieldConfigForInstance(field, i) || {}"
                >
                </app-select>

                <!-- Textarea Field -->
                <app-textarea
                  *ngSwitchCase="'textarea'"
                  [formControlName]="field.formControlName"
                  [config]="field.config || {}"
                  [validation]="field.validation || {}"
                >
                </app-textarea>

                <!-- Checkbox Field -->
                <app-checkbox
                  *ngSwitchCase="'checkbox'"
                  [formControlName]="field.formControlName"
                  [config]="field.config || {}"
                >
                </app-checkbox>

                <!-- Radio Field -->
                <app-radio
                  *ngSwitchCase="'radio'"
                  [formControlName]="field.formControlName"
                  [config]="field.config || {}"
                >
                </app-radio>

                <!-- Date Field -->
                <app-datepicker
                  *ngSwitchCase="'date'"
                  [formControlName]="field.formControlName"
                  [config]="field.config || {}"
                  [validation]="field.validation || {}"
                >
                </app-datepicker>

                <!-- File Upload Field -->
                <app-file-upload
                  *ngSwitchCase="'file'"
                  [formControlName]="field.formControlName"
                  [componentConfig]="field.config || {}"
                >
                </app-file-upload>

                <!-- Time Field -->
                <app-timepicker
                  *ngSwitchCase="'time'"
                  [formControlName]="field.formControlName"
                  [config]="field.config || {}"
                  [validation]="field.validation || {}"
                ></app-timepicker>
              </ng-container>
            </div>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <!-- Error Messages -->
  <div *ngIf="showErrorState" class="field-group-errors">
    <span class="error-text">
      <i class="bi bi-exclamation-circle me-1"></i>
      {{ currentErrorMessage }}
    </span>
  </div>
</div>
